import React from 'react'

function Advertisement({ url }) {
    return (
        <div className="mt-4 left-right bg-clr-white p-3">
            <h3 className="section-title-left align-self pl-2 mb-sm-0 mb-3">Advertise with us </h3>
            <a className="btn btn-style btn-primary" href={`${url}`}>Learn more</a>
        </div>
    )
}

export default Advertisement
